// A cleared number input reports '' instead of no value, which yup would otherwise fail
// to cast. Use as `.transform(emptyStringToNull)` on a `.nullable()` number.
export const emptyStringToNull = <T>(value: T, originalValue: unknown) =>
  originalValue === '' ? null : value;
